import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { MatIcon } from '@angular/material/icon'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-work-stations-indicator',
  templateUrl: './work-stations-indicator.component.html',
  styleUrls: ['./work-stations-indicator.component.scss'],
  imports: [MatIcon, AsyncPipe],
})
export class WorkStationsIndicatorComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public workStationIds$ = new BehaviorSubject<string[]>(null)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set workStationIds(ids: string[]) {
    this.workStationIds$.next(ids)
  }
}
